<template>
  <div class="outer-wraper-step-one">
    <div class="inner-wraper-step-one">
      <section
        class="d-inline-flex flex-column align-self-center mt-0 input-gaps input-section"
      >
        <label class="d-flex flex-column ">
          <label class="rtl-text-align-step-one label-style"
            >{{ $t('_web_profile_setup-user-name', 'User Name') }}
            <img
              class="exclamationCircle"
              src="@/assets/images/icons/exclamationRing.svg"
              alt="circle exclamation"
            />
          </label>
          <input
            v-model="accountUserName"
            disabled
            class="inputs"
            placeholder="$$t('Display Name', 'placeholder-display-name')"
          />
        </label>
        <label class="d-flex flex-column">
          <label class="rtl-text-align-step-one"
            >{{ this.$$t('Display Name', 'label-display-name') }}
            <img
              class="exclamationCircle"
              src="@/assets/images/icons/exclamationRing.svg"
              alt="circle exclamation"
          /></label>
          <input
            v-model="accountDisplayName"
            required
            class="inputs"
            placeholder="$$t('Display Name', 'placeholder-display-name')"
          />
        </label>
        <label class="d-flex flex-column">
          <label class="rtl-text-align-step-one label-style">{{
            this.$t(
              '_web_profile_setup_country_question',
              'Where are you from?'
            )
          }}</label>
          <Country
            v-model="accountCountry"
            v-validate="'required'"
            name="country"
            :error="errors.first('country')"
            class="country_input"
          />
        </label>
      </section>
      <section class="image-upload-section-wrap">
        <div>
          <ImageUpload
            v-model="accountCover"
            :height="290"
            :width="805"
            class="uploadCover"
            :placeholder="$t('_web_account_add-cover-image', 'Cover Image')"
            hide-label
          />
        </div>
        <label
          class=" upload-avatar-step-one d-flex align-self-center justify-content-center"
        >
          <ImageUpload
            v-model="accountAvatar"
            :style="{ height: '130px', width: '130px' }"
            :placeholder="
              $t('_web_profile_setup_add-avatar-image', 'Profile Image')
            "
            hide-label
            class="inner-avatar"
          />
        </label>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { translate } from '@/mixins/translate';
import ImageUpload from '../components/ImageUpload.vue';
// import TextLabel from '@/components/atoms/TextLabel';
// import TextInput from '@/components/atoms/form/HeraFormTextInput';
import Country from '@/components/molecules/form/autoComplete/Country';

export default {
  name: 'ProfileSetupInfo',
  components: {
    // TextInput,
    // TextLabel,
    ImageUpload,
    Country,
  },
  inject: ['$validator'],
  mixins: [translate('_web_profile-setup_info')],
  computed: {
    ...mapState('my', ['account', 'accountType', 'accountId']),
    ...mapGetters(['accountEditData']),
    accountAvatar: {
      get() {
        return this.$lodash.get(
          this.accountEditData,
          '__avatar.display_uri',
          this.account._avatar
        );
      },
      set(avatar) {
        if (!avatar || avatar.name) {
          this.updateEditData({
            __avatar: avatar,
          });
        }
      },
    },
    accountCover: {
      get() {
        return this.$lodash.get(
          this.accountEditData,
          '__cover.display_uri',
          this.account._cover
        );
      },
      set(cover) {
        this.updateEditData({
          __cover: cover,
        });
      },
    },
    accountDisplayName: {
      get() {
        return this.accountEditData.display_name || this.accountId;
      },
      set(displayName) {
        const display_name = displayName || this.accountId;
        this.updateEditData({
          display_name,
        });
      },
    },
    accountUserName: {
      get() {
        return this.accountEditData.login;
      },
      set(login) {
        this.updateEditData({
          login,
        });
      },
    },
    accountCountry: {
      get() {
        return this.accountEditData.country;
      },
      set(country) {
        this.updateEditData({
          country: country ? country.value : '',
          country_id: country ? country.id : '',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
  },
};
</script>

<style lang="scss">
.profile-setup-info {
  .setup-avatar {
    @include auto-rtl(margin-right, 1.5rem !important);

    label {
      padding: 2rem;
      & > span:first-child {
        text-align: left;
      }
    }
  }
}

html[dir='rtl'] {
  .country_input {
    .autosuggest_clear-icon {
      right: 23rem !important;
    }
  }
}

.outer-wraper-step-one {
  font-family: $hr-font-family;
  text-align: center;
  .inner-wraper-step-one {
    display: inline-flex !important;
    justify-content: space-between;
    width: 928px;
    .input-gaps {
      gap: 10px;
    }
    .label-style {
      color: $new-fg-disabled !important;
      font-weight: 600;
      font-style: italic;
      font-size: 12px !important;
    }
    .inputs {
      background-color: $new-bg-base;
      border-radius: 5px;
      width: 100% !important;
      height: 40px;
      border: 1px solid $new-border-neutral;
      color: white;
      font-weight: 400;
      padding-left: 12px;
      padding-right: 12px;
      &::placeholder {
        color: $hr-text-secondary;
      }
      &:disabled {
        background-color: $new-bg-neutral-faded;
        border: 1px solid $new-border-disabled;
        font-weight: 400;
        color: $hr-text-primary;
      }
      label {
        font-weight: 400;
      }
    }
    .image-upload-section-wrap {
      position: relative;
      min-width: 544px;
      height: 272px;
      .upload-avatar-step-one {
        position: absolute !important;
        left: 36px;
        bottom: 27px;
        width: 130px;
        height: 130px;
      }
      .inner-avatar {
        font-weight: 400 !important;
      }
    }
  }
  .rtl-text-align-step-one {
    text-align: start;
    font-weight: 400;
  }

  @media (max-width: 1100px) {
    .input-section {
      width: 35vw !important;
    }
    .input-form {
      width: 35vw !important;
    }
    .autosuggest_input-wrapper {
      width: 35vw !important;
    }
    .country_input {
      width: 35vw !important;
    }
    .image-upload-section-wrap {
      min-width: 35vw !important;
    }
    .file-upload-field {
      background-size: 35vw 272px;
      border-radius: 20px;
    }
    .inner-wraper-step-one {
      width: 100% !important;
    }
  }

  @media (max-width: 940px) {
    .outer-wraper-step-one {
      justify-content: center !important;
    }
    .inner-wraper-step-one {
      flex-direction: column;
      align-items: center;
      width: 100% !important;
      .input-gaps {
        margin-right: 0;
        margin-bottom: 2rem;
      }
      .responsive-bottom {
        margin-top: 0;
      }
      .input-section {
        width: 100% !important;
      }
      .input-form {
        width: 100% !important;
      }
      .autosuggest_input-wrapper {
        width: 100% !important;
      }
      .country_input {
        width: 100% !important;
      }
      .image-upload-section-wrap {
        min-width: 100% !important;
      }
      .file-upload-field {
        background-size: 100% 272px;
      }
    }
  }

  @media (max-width: 420px) {
    .image-upload-section-wrap {
      position: relative;
      min-width: 544px;
      height: 272px;
      margin-bottom: 10rem !important;
      .upload-avatar-step-one {
        left: 0px !important;
        top: 300px;
      }
      .input-section {
        width: 100% !important;
      }
      .input-form {
        width: 100% !important;
      }
      .autosuggest_input-wrapper {
        width: 100% !important;
      }
      .country_input {
        width: 100% !important;
      }
      .image-upload-section-wrap {
        min-width: 100% !important;
      }
      .file-upload-field {
        background-size: 100% 272px;
      }
    }
  }
}

.country_input {
  .input-form {
    background-color: $new-bg-base;
    border-radius: 5px;
    height: 40px;
    border: 1px solid $new-border-neutral;
    color: white;
    font-weight: 400;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 0px;
  }
  .autosuggest_clear-icon {
    top: 1rem !important;
    right: 0.5rem !important;
  }
  .autosuggest_input-wrapper {
    width: 352px;
  }
}

.exclamationCircle {
  margin-bottom: 1px;
}

.uploadCover {
  .wrapper-control {
    height: 272px;
    background-color: transparent;
  }
  .file-upload-field label {
    background-color: transparent;
    height: 272px;
  }
  .upload-image-preview {
    border-radius: 5px !important;
    height: 272px;
    background-color: transparent;
  }
  .upload-image-wrapper {
    height: 272px;
    border-radius: 5px !important;
    background-color: transparent;
  }
  .embed-responsive-item {
    height: 272px;
    background-color: transparent;
  }
  .file-upload-field {
    border-radius: 5px !important;
    height: 272px;
    background: linear-gradient(
        0deg,
        rgba(11, 14, 19, 0.8),
        rgba(11, 14, 19, 0.8)
      ),
      url('../../../assets/images/background/upload-placeholder.png');
    background-repeat: no-repeat;
    background-size: 544px 272px;
    background-position: center;
    border-color: $new-border-neutral !important;
  }
  input {
    border-radius: 5px !important;
  }
}
</style>
